import $ from 'jquery';
import styles from './theme1.less';
import BScroll from '@better-scroll/core';
import { iconfont } from '../../utils/utils';

class detailsList {
  constructor(props){
    const { wrapper, ...params } = props;
    this.wrapper = wrapper;
    this.params = {
      ...params,
    };
    this.activePano = null; //激活的 细节 对象
    this.visitedPanos = []; //访问过的细节id

    const { data } = this.params;
    if (!data || !data.length) {
      this._removeDetailsWrapper();
      return;
    }
    this.isShow = false;

    this._initDom();
  }

  _initDom() {
    this._removeDetails();
    const dom = document.getElementsByClassName(`${styles['details-list-wrapper']}`);
    if (dom.length == 0) {
      this.$dom = this._createWrapper();
      setTimeout(() => {
        if(!this.isShow){
          this.$dom.css('display', 'none');
        }
      }, 40);
    }else{
      this.$dom = $(dom);
      if (this.$dom.css('display') == 'block') {
        this.isShow = true;
        setTimeout(() => {
          if(this.isShow){
            this.$dom.css('display', 'block');
          }
        }, 40);
      }
    }

    this._initList();
    $(this.wrapper).append(this.$dom);
  }

  _createWrapper() {
    return $(
      `<div class="${styles['details-list-wrapper']} ${styles['details-list-wrapper-theme1']} details-list"></div>`,
    );
  }

  _initList() {
    //生成所有分组
    let $list;
    const { data } = this.params;
    const _this = this;
    $list = this._createDetailsList(data);
    this.$dom.prepend($list);
    //事件
    $(document).on('click', `.${styles['details-wrapper']}`, function() {
      _this._handleDetailsClick($(this));
    });
  }

  _createDetailsList(list) {
    this.curPanoList = list;
    let $wrapper = $(`
      <div class="${styles['details-wrapper']} ${styles['list-wrapper']} ${
      this.isShow ? styles['show'] : ''
    }">
      <div class="details-view-scrollX-wrapper">
        <div class="details-view-scrollX-content"></div>
      </div>
    </div>`);
    let $ul = $('<ul></ul>');
    list.forEach((el, i) => {
      let $li = $('<li></li>');
      $li.append(
        this._getDetailsItem({
          item: el,
          index: i,
        }),
      );
      $ul.append($li);
    });

    if (this.$detailsList) {
      const content = this.$detailsList.find('.details-view-scrollX-content');
      content.html('').append($ul);
    } else {
      $wrapper.find('.details-view-scrollX-content').append($ul);
      this.$detailsList = $wrapper;
      this.$dom.prepend(this.$detailsList);
    }

    setTimeout(() => {
      this._intiScroll($wrapper.find('.details-view-scrollX-wrapper').get(0));
    }, 20);

    return $wrapper;
  }

  _getDetailsItem(params) {
    const { item } = params;
    
    //生成全景item
    if (!item) return;
    const { title, id, url_path, ath, atv, fov } = item;

    const isActivePano = this.activePano && this.activePano.id == id ? true : false;
    const isVisitedPano = this.visitedPanos.includes(String(id)) ? true : false;
    let $item = $(`
      <div 
      class="${styles['details-wrapper']} ${styles['item-wrapper']} ${
      isActivePano ? styles['active'] : ''
    } ${isVisitedPano ? styles['visited'] : ''}" 
      data-id="${id}" data-ath="${ath}" data-atv="${atv}" data-fov="${fov}" data-name="${title}" title="${title}">
      <div 
      class="${styles['details-item']} ${styles['list-item']}" 
      style="background-image:url('${url_path}')">
        ${
          isVisitedPano
            ? `<span class="${styles['visited-icon']}">${iconfont('icondui')}</span>`
            : ''
        }
          <div class="${styles['details-name']} ${styles['item-name']}"><span>${title}</span></div>
        </div>
      </div>`);
    return $item;
  }

  _removeDetailsWrapper() {
    $(document.getElementsByClassName(`${styles['details-list-wrapper']}`)[0]).remove();
  }

  _removeDetails() {
    if (document.getElementsByClassName(`${styles['details-wrapper']}`)) {
      $(document.getElementsByClassName(`${styles['details-wrapper']}`)[0]).remove();
    }
  }

  _intiScroll(scrollWrapper) {
    new BScroll(scrollWrapper, {
      scrollX: true,
      click:true
    });
  }

  _handleDetailsClick($details) {
    const ath = $details.attr('data-ath');
    const atv = $details.attr('data-atv');
    const fov = $details.attr('data-fov');
    const data = {
      hlookat:ath,
      vlookat:atv,
      fov:fov
    }
    this._changePano({id:$details.attr('data-id')})
    this.params.onDetailsClick(data);
  }

  _changePano(data) {
    if (data.id) {
      this._setCurPano(data);
      this._createDetailsList(this.curPanoList);
    }
  }

  _setCurPano(data) {
    this.activePano = data;
    if (!this.visitedPanos.includes(String(data.id))) {
      this.visitedPanos.push(data.id);
    }
  }

  show() {
    const lists = this.$dom.find(`.${styles['list-wrapper']}`);
    this.$dom.css('display', 'block');
    lists.removeClass(styles['hide']).addClass(styles['show']);
    this.isShow = true;
  }

  hide() {
    let lists;
    if (document.getElementsByClassName(`${styles['details-list-wrapper']}`).length > 0) {
      lists = this.$dom.find(`.${styles['list-wrapper']}`);
      lists.removeClass(styles['show']).addClass(styles['hide']);
      setTimeout(() => {
        this.$dom.css('display', 'none');
      }, 250);
      this.isShow = false;
    }else{
      return;
    }
  }

  toggle() {
    if (this.isShow) {
      this.hide();
    } else {
      this.show();
    }
  }

}

export default detailsList;
